export default "__VITE_ASSET__B10ykiGc__"